// 考勤异常管理API
import request from '@/utils/request'

export const pageListApi = (data) => {
    return request({
        url: 'AttendanceAnomaly/adminList',
        method: 'post',
        data
    })
}

export const auditApi = (data) => {
    return request({
        url: 'AttendanceAnomaly/audit',
        method: 'post',
        data
    })
}
